import styled from '@emotion/styled'
import {
  baseAccordionContainer,
  baseAccordionHeader,
} from '../styles/Panel.styles'
import theme from '../../../styles/theme'

// Interface for components that use isActive prop
interface ActiveProps {
  isActive?: boolean
}

export const AccordionContainer = styled.div`
  ${baseAccordionContainer}
  gap: 20px;
`

export const PanelContainer = styled.div`
  background-color: ${`${theme.colors.second}80`};
  box-shadow: ${theme.shadows.light};
  border-radius: 1.1rem;
  margin-bottom: 1.5rem;
`

export const DynamicHeader = styled.div<ActiveProps>`
  ${baseAccordionHeader}
  background-color: transparent;
  padding: 1rem;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
    border-bottom-left-radius: ${(props) => (props.isActive ? '0' : '1.5rem')};
    border-bottom-right-radius: ${(props) => (props.isActive ? '0' : '1.5rem')};
  }
`

export const IconContainer = styled.div<ActiveProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    color: ${theme.colors.secondHighlight};
  }
`

export const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
`

export const PanelContent = styled.div`
  padding: 1rem;
  will-change: height, opacity;
`
